import { FC } from 'react';
import styled from 'styled-components';

import { PremierText } from '@components/text';
import { ParticipantRole } from '@typings/participant';
import { roleLabels } from '@utils/constants/avatar';
import { SKEW_ANGLE } from '@utils/constants';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: skew(-${SKEW_ANGLE}deg);
  background: ${({ theme }) =>
    `linear-gradient(
    90deg,
    ${theme.colors.red[500]} 20%,
    ${theme.colors.purple[500]} 50%,
    ${theme.colors.blue[500]} 80%
  )`};
  padding-inline: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-inline: 8px;
  }
`;

const Text = styled(PremierText)`
  padding: 2px 16px;
  font-size: ${({ theme }) => theme.fonts.fontSize.lg};
  color: ${({ theme }) => theme.colors.white};
  transform: skew(${SKEW_ANGLE}deg);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fonts.fontSize.base};
  }
`;

type Props = {
  role: ParticipantRole;
};

const HostLabel: FC<Props> = ({ role }) => {
  return (
    <Container>
      <Text>{roleLabels[role]}</Text>
    </Container>
  );
};

export default HostLabel;
